import styled from '@emotion/styled';
import * as React from '@emotion/react';
import { NUM_OF_CARDS, BAR_COLOR_CODING_MAP } from '../utils/constants';
import { BG_COLOR_PROPERTIES } from '../models/colors-props';
import {
  CardClickHandlerType,
  KeyPressHandlerType
} from '../models/interaction-handler-props';
import { CardProps, ColorBarProps } from '../models/card-props';
import { CardDetailsContainer } from './card-details';

export const renderCards = (
  cardClickHandler: CardClickHandlerType,
  keyPressHandler: KeyPressHandlerType,
  isColorBar: boolean,
  isCategoryLabel: boolean,
  colorCoding: BG_COLOR_PROPERTIES,
  barColor?: string
) => {
  const cardList = [];
  for (let cardId = 1; cardId <= NUM_OF_CARDS; cardId++) {
    cardList.push(
      <Card
        key={cardId}
        className={`card card${cardId}`}
        colorCoding={colorCoding}
        role="button"
        tabIndex={0}
        onClick={(e) => cardClickHandler(cardId, e)}
        onKeyDown={(e) => keyPressHandler(cardId, e)}
        aria-labelledby={`label` + cardId}
        aria-describedby={`title` + cardId + ` description` + cardId}
      >
        {isColorBar && (
          <ColorBar
            key={cardId}
            className={`bar bar${cardId}`}
            barColor={barColor}
          />
        )}
        <CardDetailsContainer
          categoryTypeColor={colorCoding.categoryTypeColor}
          isCategoryLabel={isCategoryLabel}
          cardId={cardId}
        />
      </Card>
    );
  }
  return cardList;
};

export const Card = styled.div<CardProps>`
  display: flex;
  flex-basis: auto;
  min-width: inherit;
  cursor: pointer;
  flex-direction: row;

  @media only screen and (max-width: 1023px) {
    margin-right: 16px;
    margin-left: 16px;
    flex-direction: column;
  }

  @media only screen and (max-width: 767px) {
    min-width: 100%;
    flex-shrink: 0;
    margin-right: 0px;
    margin-left: 0px;
    display: inline-flex;
  }
`;

export const ColorBar = styled.div<ColorBarProps>`
  width: 8px;
  background-color: ${(props) =>
    props.barColor &&
    BAR_COLOR_CODING_MAP.has(props.barColor) &&
    BAR_COLOR_CODING_MAP.get(props.barColor)};

  @media only screen and (max-width: 1023px) {
    width: 100%;
    min-height: 8px;
    max-height: 8px;
  }
`;
